import { Edit05, Trash04 } from '@aktiia/design-system';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../../../../../../enums';
import { useOpenModal } from '../../../../../../../../features/modals';
import { IUserMenuPopoverProps } from './types';

export const UserMenuPopover = ({ user }: IUserMenuPopoverProps) => {
  const { t } = useTranslation();
  const openChangeUserRoleModal = useOpenModal(ModalName.CHANGE_USER_ROLE);
  const openDeleteUserModal = useOpenModal(ModalName.DELETE_USER);

  const handleChangeRole = useCallback(() => {
    openChangeUserRoleModal({ user });
  }, [openChangeUserRoleModal]);

  const handleDelete = useCallback(() => {
    openDeleteUserModal({ user });
  }, [openDeleteUserModal]);

  return (
    <div className="flex flex-col bg-background-surface-primary w-[220px] rounded-xl shadow-high">
      <div
        className="flex items-center hover:bg-global-zurich-10 px-4 h-[40px] w-full rounded-t-xl cursor-pointer border-b border-border-divider"
        onClick={handleChangeRole}
      >
        <span className="typography-title-3 text-text-primary">{t('organization.users.button.changeRole')}</span>
        <div className="grow" />
        <Edit05 className="text-text-secondary" />
      </div>
      <div
        className="flex items-center hover:bg-global-zurich-10 px-4 h-[40px] w-full rounded-b-xl cursor-pointer"
        onClick={handleDelete}
      >
        <span className="typography-title-3 text-text-primary">{t('organization.users.button.delete')}</span>
        <div className="grow" />
        <Trash04 className="text-text-negative" />
      </div>
    </div>
  );
};
